import { render, staticRenderFns } from "./DiySearch.vue?vue&type=template&id=4c16c89c&scoped=true&"
import script from "./DiySearch.vue?vue&type=script&lang=js&"
export * from "./DiySearch.vue?vue&type=script&lang=js&"
import style0 from "./DiySearch.vue?vue&type=style&index=0&id=4c16c89c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c16c89c",
  null
  
)

export default component.exports